// extracted by mini-css-extract-plugin
module.exports = {"mediaLink":"ContentOverviewTeaser__mediaLink","container":"ContentOverviewTeaser__container"};